import React, { useState, useEffect } from "react";

import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";

import UserNovel from "./UserNovel";
import SuccessEye from "../../../components/Nav & Header/EyeNoData";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";

import {
  deleteNovels,
  updateNovels,
  createNovelsChaps,
  updateNovelsChaps,
  deleteNovelsChaps,
  deleteNovelsChapsAll,
} from "../../../3- actions/novels";
import Delete from "./Crud/Delete";
import Update from "./Crud/Update";
import AddUpdate from "./Crud/AddUpdate";
import { deleteComments } from "../../../3- actions/comments";
function UserNovels({ novel, user }) {
  const dispatch = useDispatch();
  const [novelDataU, setNovelDataU] = React.useState({
    title: "",
    description: "",
    selectedFile: "",
    tags: "",
  });
  const [novelChapsU, setNovelChapsU] = React.useState([]);

  // novelId You click on
  const [getNovelId, setGetNovelId] = useState(null);

  const [error, setErrors] = useState("");
  const [success, setSuccess] = useState(false);
  const [sent, setSent] = useState(false);
  const [deletePopup, setDeletePopUp] = useState(false);
  const [updatePopup, setUpdatePopUp] = useState(false);

  const [chapterPopup, setChapterPopup] = useState(false);

  const [rejectPushing, setRejectPushing] = useState(false);
  const [updatedChapsId, setUpdatedChapsId] = useState([]);
  // im using this id to send it with chap object so i can dispatch
  const [updatedChaps, setUpdatedChaps] = useState(null);
  // i put chap Id that i clicked or wanted to be removed
  const [deletedChapsId, setDeletedChapsId] = useState([]);
  // popups
  const [notChapter, setNotChapter] = useState(5);
  //slicing empty objects
  const [slicingEmptyObjects, setSlicingEmptyObjects] = useState(false);

  // CreateNewChaps
  const [indexOfChap, setIndexOfChap] = useState(0);
  const [addChap, setAddChap] = useState(false);

  const [successPopUp, setSuccessPopUp] = useState(false);
  const [limitpopup, setLimitPopup] = useState(false);
  const [tagsScroll, setTagsScroll] = useState(true);
  const [checked, setChecked] = useState([]);
  // Add/Remove checked item from list
  function handleCheck(e) {
    var updatedList = [...checked];
    if (e.target.checked) {
      updatedList = [...checked, e.target.value];
    } else {
      updatedList.splice(checked.indexOf(e.target.value), 1);
    }
    setChecked(updatedList);
  }

  // changing noveldataU to checked
  useEffect(() => {
    // SetPopupfalse();
    setNovelDataU({
      ...novelDataU,
      tags: checked,
    });
  }, [checked]);

  // delete novel and everything related to it in
  // terms of chapters and comments
  function DeleteNovel() {
    setSent(true);
    dispatch(deleteNovels(getNovelId))
      .then(unwrapResult)
      .then(() => {
        dispatch(deleteNovelsChapsAll(getNovelId));
        dispatch(deleteComments(getNovelId));
        setDeletePopUp(false);
        setSent(false);
      })
      .catch((err) => console.error(err));
  }

  function clear() {
    setGetNovelId(null);
    setUpdatePopUp(false);
    setSent(false);
    setSuccessPopUp(true);
  }
  // take my UpdatedNovelChaps and delete
  // duplicated in terms of id (UpdatedId)
  // only leave latest data
  let result = {};
  updatedChapsId.forEach((val) => {
    result[val.UpdatedId] = val;
  });
  let results = Object.values(result);
  function handleSubmitUpdate(e) {
    let titleRule = novelDataU.title?.trim()?.split(/ +/)?.join(" ");
    let desRule = novelDataU.description?.trim()?.split(/ +/)?.join(" ");
    let tagsRule = novelDataU.tags.length < 3;
    let imgRule = !novelDataU.selectedFile;
    const fileSize = novelDataU.selectedFile.length * (3 / 4) - 2;

    e.preventDefault();
    setSent(true);
    if (titleRule.length < 5) {
      setSuccess(false);
      setSent(false);
      setErrors("title must be at least 5 Charaters!");
    } else if (desRule.length < 250) {
      setSuccess(false);
      setSent(false);
      setErrors("description must be at least 250 Charaters!");
    } else if (tagsRule) {
      setSuccess(false);
      setSent(false);
      setErrors("3 tags is required to continue!");
      setLimitPopup(true);
      setTimeout(() => {
        setLimitPopup(false);
      }, 2000);
    } else if (imgRule) {
      setSuccess(false);
      setSent(false);
      setErrors("image is required to continue!");
    } else if (fileSize > 1000000) {
      setSuccess(false);
      setSent(false);
      setErrors("Your image must be bellow 1 mega bytes!");
    } else {
      function updateNovel() {
        const novelData = {
          userId: getNovelId,
          obj: {
            ...novelDataU,
            chaptersLength: novelChapsU?.length,
            likes: novelDataU?.likes,
          },
        };
        dispatch(updateNovels(novelData))
          .then(unwrapResult)
          .then(() => {
            clear();
          })
          .catch((err) => console.log("updateNovelErr", err));
      }
      function updateChaps() {
        results?.map((novelC) => {
          const chapsData = {
            userId: novelC.UpdatedId,
            obj: novelC,
          };
          return dispatch(updateNovelsChaps(chapsData));
        });
      }
      function newChaps() {
        novelChapsU
          ?.filter((novel) => !novel._id)
          .map((novel, index) => {
            if (novelChapsU?.length - 1 === index) {
              setNovelChapsU([]);
            }
            return dispatch(createNovelsChaps(novel));
          });
      }
      function deletedChaps() {
        const deletedChapsIdWithoutNull = deletedChapsId.filter((element) => {
          return element !== undefined;
        });
        deletedChapsIdWithoutNull?.map((novel) =>
          dispatch(deleteNovelsChaps(novel))
        );
      }
      // dispatch data that includes in my state
      // which comes whenever i click on delete chapter
      // remove undifened first
      deletedChaps();
      // Update chapsData
      updateChaps();
      // dispatch data that doen't have An _ID which --
      // means data that i just added to the array
      newChaps();
      // dispatch updated novelDataU
      updateNovel();
    }
  }

  let successmessage = (
    // Get started popup
    <div>
      <div
        className={
          successPopUp
            ? "-translate-y-[0%] opacity-100 w-full md:w-full lg:w-full xl:w-[80%]  2xl:w-[70%] h-full md:h-[90%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] "
            : "translate-y-[200%] opacity-0 w-full md:w-full lg:w-full xl:w-[80%]  2xl:w-[70%] h-full md:h-[90%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] "
        }
      >
        <div className="w-full md:w-full lg:w-full xl:w-full  2xl:w-full h-full md:h-full">
          <div className=" bg-tertiary relative md:static overflow-y-scrsoll z-[1000] w-full md:w-full lg:w-full xl:w-full 2xl:w-full h-full md:h-full duration-500 ease-in-out">
            <div className=" bg-primary py-[100px] md:py-16 px-[15px]  gap-y-4 md:px-0 w-full  flex justify-center items-center flex-col text-center ">
              <div className="successZoom">
                <SuccessEye />
              </div>
              <div>
                <h2 className="text-tertiary max-w-[80%] m-auto font-size py-2">
                  your novel has been successfully updated!
                </h2>
              </div>
            </div>
            <div className="  flex justify-center items-start text-center pt-16 text-primary ">
              <h2
                onClick={() => setSuccessPopUp(false)}
                className="capitalize text-[14px] md:text-[16px] font-SoraS relative cursor-pointer linebutton"
              >
                Ok thanks
              </h2>
            </div>
            {/* remove button */}
            <div
              onClick={() => setSuccessPopUp(false)}
              className=" cursor-pointer absolute bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
            >
              <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      {/* <Novelsbyuser /> */}
      <div className="sm:mt-[80px] mt-[50px]">
        <div className="relative grid gap-4 sm:gap-8 md:gap-10 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 w-[100%] ">
          {novel?.map((novel) => (
            <div key={novel._id}>
              <UserNovel
                id={novel._id}
                novel={novel}
                setNovelChapsU={setNovelChapsU}
                setChecked={setChecked}
                setNovelDataU={setNovelDataU}
                setGetNovelId={setGetNovelId}
                setDeletePopUp={setDeletePopUp}
                setUpdatePopUp={setUpdatePopUp}
              />
            </div>
          ))}
        </div>
      </div>

      {/* popup */}
      <div
        onClick={() => {
          setDeletePopUp(false);
          setUpdatePopUp(false);
          setSuccessPopUp(false);
          setDeletedChapsId([]);
          setUpdatedChapsId([]);
        }}
        className={
          deletePopup || updatePopup || successPopUp
            ? "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-100  duration-500 ease-in-out"
            : "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-0 pointer-events-none duration-500 ease-in-out"
        }
      ></div>
      <div
        onClick={() => {
          setAddChap(false);
          setDeletedChapsId([]);
          setUpdatedChapsId([]);
        }}
        className={
          addChap
            ? "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-100  duration-500 ease-in-out"
            : "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-0 pointer-events-none duration-500 ease-in-out"
        }
      ></div>

      {/* repliesPopup */}
      <Update
        getNovelId={getNovelId}
        setSlicingEmptyObjects={setSlicingEmptyObjects}
        setRejectPushing={setRejectPushing}
        updatedChaps={updatedChaps}
        deletedChapsId={deletedChapsId}
        setUpdatedChaps={setUpdatedChaps}
        setUpdatedChapsId={setUpdatedChapsId}
        setDeletedChapsId={setDeletedChapsId}
        setNotChapter={setNotChapter}
        notChapter={notChapter}
        setIndexOfChap={setIndexOfChap}
        chapterPopup={chapterPopup}
        setChapterPopup={setChapterPopup}
        novelChapsU={novelChapsU}
        setNovelChapsU={setNovelChapsU}
        updatePopup={updatePopup}
        handleSubmitUpdate={handleSubmitUpdate}
        novelDataU={novelDataU}
        setNovelDataU={setNovelDataU}
        setTagsScroll={setTagsScroll}
        tagsScroll={tagsScroll}
        checked={checked}
        setUpdatePopUp={setUpdatePopUp}
        setSuccessPopUp={setSuccessPopUp}
        setAddChap={setAddChap}
        limitpopup={limitpopup}
        handleCheck={handleCheck}
        error={error}
        success={success}
        sent={sent}
      />
      {/* addChaps */}
      <AddUpdate
        getNovelId={getNovelId}
        slicingEmptyObjects={slicingEmptyObjects}
        rejectPushing={rejectPushing}
        updatedChaps={updatedChaps}
        updatedChapsId={updatedChapsId}
        setNotChapter={setNotChapter}
        novelDataU={novelDataU}
        indexOfChap={indexOfChap}
        novelChapsU={novelChapsU}
        setNovelChapsU={setNovelChapsU}
        addChap={addChap}
        setAddChap={setAddChap}
      />
      {/* delete button */}
      <Delete
        sent={sent}
        DeleteNovel={DeleteNovel}
        deletePopup={deletePopup}
        setDeletePopUp={setDeletePopUp}
      />
      {/* successmessage */}
      {successmessage}
    </div>
  );
}

export default UserNovels;
